import { Order } from "./order";

export interface Ingredient {
    ID: number;
    IngredientName: string;
    Price: string;
    Info: string;
    Show: boolean;
    IsHidden: number;
    SelectedCount: number;
    internalSets: Set[];
    DealOrderMenu: Order;
    PaidCount: number;
    totalPrice: number; 
    isPressed: boolean; // For touch feedback
}

// models/set.model.ts
export interface Set {
    ID: number;
    SetName: string;
    Ingredients: Ingredient[];
    IsRequired: number;
    RequiredCount: number;
    MaxCount: number;
    IsMultiple: number;
    FreeCount: number;
    MenuID: number;
    DealMenu: Deal;

    ChooseEnough : 'normal' | 'shake' | 'ChooseEnough';
    TextForRequired : string;
    isGreenFree : boolean;
    IsFreeShow : boolean;
    priceToPay : number
}
export interface Deal
{   
    CountNumber : number;
    MenuID : number;
    MenuName : string;
    OrderListID : number;
}



// models/sets-list.model.ts
export interface SetsList {
    list: Set[];
    runtimeDate: string;
    error: boolean;
    responseMessage: string;
    message: string;
    messageDetail: string;
    OrderListID: number;
    DinerName: string;
    Comments: string;
    BigImageFile: string;
    CountNumber: number;
    Description: string;
    OrderID: number;
    Price: number;

}

export interface DeletedInnerMenus {
    OrderListID: number;
    CountNumber: number;
}

export class DealClass implements Deal {
    CountNumber: number = 0;
    MenuID: number = 0;
    MenuName: string = '';
    OrderListID: number = 0;
    constructor(data?: Partial<Deal>) {
        if (data) {
            Object.assign(this, data);
        }
    }
}
export class IngredientClass implements Ingredient {
    ID: number = 0;
    IngredientName: string = '';
    Price: string = '';
    Info: string = '';
    Show: boolean = true;
    IsHidden: number = 1;
    SelectedCount: number = 0;
    internalSets: Set[] = [];
    DealOrderMenu: Order = new Order();
    PaidCount: number = 0;

    totalPrice: number = 0;

    isPressed: boolean = false; // For touch feedback
    constructor(data?: Partial<Ingredient>) {
        if (data) {
            Object.assign(this, data);
        }
    }
}

export class SetClass implements Set {
    ID: number = 0;
    SetName: string = '';
    Ingredients: Ingredient[] = [];
    IsRequired: number = 0;
    RequiredCount: number = 0;
    MaxCount: number = 0;
    IsMultiple: number = 0;
    FreeCount: number = 0;
    TextForRequired : string = '';
    DealMenu: Deal = new DealClass();
    IsFreeShow : boolean = false ;
    isGreenFree: boolean = false;
    priceToPay:number = 0;
    MenuID: number = 0;
    ChooseEnough :'normal' | 'shake' | 'ChooseEnough' = "ChooseEnough";
    constructor(data?: Partial<Set>) {
        if (data) {
            Object.assign(this, data);
        }
    }
}

export class SetsListClass implements SetsList {
    list: Set[] = [];
    runtimeDate: string = '';
    error: boolean = false;
    responseMessage: string = '';
    message: string = '';
    messageDetail: string = '';
    OrderListID: number = 0;
    DinerName: string = '';
    Comments: string = '';
    BigImageFile: string = '';
    CountNumber: number = 0;
    Description: string = '';
    OrderID: number = 0;
    Price: number = 0;
    

    constructor(data?: Partial<SetsList>) {
        if (data) {
            Object.assign(this, data);
        }
    }
}



export interface IngredientSave {
    ID: number;
    Sets: SetsSave[];
}

export interface SetsSave {
    ID: number;
    Ingredients: IngredientSave[];
}


export class IngredientSaveClass implements IngredientSave {
    ID: number = 0
    Sets: SetsSave[] = [];
    constructor(data?: Partial<IngredientSave>) {
        if (data) {
            Object.assign(this, data);
        }
    }
}  

export class SetsSaveClass implements SetsSave {
    ID: number = 0
    Ingredients: IngredientSave[] = [];
    constructor(data?: Partial<SetsSave>) {
        if (data) {
            Object.assign(this, data);
        }
    }
}  